import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from './_authenticated';
import { AlbumsPage } from '@/pages/AlbumsPage';

export const albumsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: 'albums',
  component: AlbumsPage,
});
